import { useContext } from 'react';
import { LangContext } from '../context/DataContext';

const UseLang = ({ children, es, en, pt }) => {
  const { myLang } = useContext(LangContext);
  
  if ((es && myLang === 'es') || (en && myLang === 'en') || (pt && myLang === 'pt')) {
    return <>{children}</>;
  } else {
    return null; 
  }
};

export default UseLang;